import flatten from "nq/src/flatten";
import { formatDate } from "../../../components/common/Converter";
import LogoHeader from "../../../components/common/LogoHeader";

export default function PrintMedicalRec({ object }) {
  console.log("VALUE: ", object);
  const Header = () => (
    <div style={{ textAlign: "center", fontWeight: "bold", marginTop: "10px" }}>
      <h2
        style={{
          backgroundColor: "green",
          padding: "10px",
          color: "black",
          margin: "0",
        }}
      >
        Medical Records
      </h2>
    </div>
  );

  const Section = ({ title, fields, type }) => (
    <div>
      <h4
        style={{
          backgroundColor: "#4CAF50",
          color: "black",
          padding: "5px 10px",
          margin: "0",
        }}
      >
        {title}
      </h4>
      <table
        style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}
      >
        <tbody>
          {fields.map((field) => {
            const empName = `${object?.employee?.Firstname || ""} ${
              object?.employee?.Middlename || ""
            } ${object?.employee?.surname || ""}`.trim();

            let fieldValue = object[field.name];

            if (Array.isArray(fieldValue)) {
              fieldValue =
                fieldValue.length > 0
                  ? fieldValue.map((item, index) => (
                      <span key={index}>
                        {item}
                        <br />
                      </span>
                    ))
                  : "____________________";
            } else {
              fieldValue = fieldValue || "____________________";
            }

            return (
              <tr key={field.name} style={{ borderBottom: "1px solid #ddd" }}>
                <td
                  style={{
                    fontWeight: "bold",
                    width: "30%",
                    padding: "8px",
                    backgroundColor: "#f5f5f5",
                  }}
                >
                  {field.label}
                </td>
                <td style={{ width: "70%", padding: "8px" }}>
                  {field.type === "employee"
                    ? empName
                    : field.type === "date"
                    ? formatDate(fieldValue)
                    : fieldValue}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );

  const SectionMedication = ({ title, data }) => (
    <div>
      <h4
        style={{
          backgroundColor: "#4CAF50",
          color: "black",
          padding: "5px 10px",
          margin: "0",
        }}
      >
        {title}
      </h4>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
            <th style={{ padding: "8px", width: "30%" }}>Medication</th>
            <th style={{ padding: "8px", width: "30%" }}>Dosage & Frequency</th>
            <th style={{ padding: "8px", width: "40%" }}>
              Reason for Medication
            </th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(data) && data.length > 0 ? (
            data.map((entry, index) => (
              <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "8px" }}>
                  {entry[0] || "____________________"}
                </td>
                <td style={{ padding: "8px" }}>
                  {entry[1] || "____________________"}
                </td>
                <td style={{ padding: "8px" }}>
                  {entry[2] || "____________________"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ textAlign: "center", padding: "8px" }}>
                No medication records available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  const ImmunizationHistory = ({ title, data }) => (
    <div>
      <h4
        style={{
          backgroundColor: "#4CAF50",
          color: "black",
          padding: "5px 10px",
          margin: "0",
        }}
      >
        {title}
      </h4>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        {/* <thead></thead> */}
        <tbody>
          {Array.isArray(data) && data.length > 0 ? (
            data.map((entry, index) => (
              <>
                {[
                  { label: "Vaccine", value: entry[0] },
                  { label: "Doses", value: entry[1] },
                  { label: "Date Of Vaccination", value: formatDate(entry[2]) },
                  { label: "Remarks", value: entry[3] },
                ].map((item, index) => (
                  <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
                    <td
                      style={{
                        fontWeight: "bold",
                        width: "30%",
                        padding: "8px",
                        backgroundColor: "#f5f5f5",
                      }}
                    >
                      {item.label}
                    </td>
                    <td style={{ width: "70%", padding: "8px" }}>
                      {item.value || "____________________"}
                    </td>
                  </tr>
                ))}
              </>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ textAlign: "center", padding: "8px" }}>
                No medication records available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div
      style={{
        width: "95%",
        padding: 0,
        margin: "auto",
        fontFamily: "Arial, sans-serif",
        fontSize: "14px",
        border: "1px solid #ddd",
      }}
    >
      <LogoHeader
        logoSrc={"/BIR.png"}
        altText="Print Logo"
        mainLabel="Republic Of the Philippines"
        subLabel="BUREAU OF IMMIGRATION"
        description="Patriotism * Integrity * Professionalism"
        rightLogoSrc={"/Bagong-Pilipinas-Logo.png"}
      />

      {Header()}

      <Section
        title="Section I. Patient Information"
        fields={[
          { name: "fullName", label: "Full Name", type: "employee" },
          { name: "dateOfBirth", label: "Date of Birth", type: "date" },
          { name: "gender", label: "Gender" },
          { name: "department", label: "Department" },
          { name: "contactDetails", label: "Contact Details" },
          { name: "emergencyContact", label: "Emergency Contact" },
          { name: "philhealthNumber", label: "PhilHealth Number" },
        ]}
      />

      <Section
        title="Section II. Medical History"
        fields={[
          { name: "pastMedicalConditions", label: "Past Medical History" },
          { name: "familyMedicalHistory", label: "Family Medical History" },
          { name: "surgicalHistory", label: "Surgical History" },
          { name: "dentalHistory", label: "Dental History" },
          { name: "allergies", label: "Allergies" },
          { name: "obstetricHistory", label: "Obstetric History" },
        ]}
      />

      {/* <Section
        title="Section III. Immunization History"
        fields={[
          { name: "vaccine", label: "Vaccine" },
          { name: "doses", label: "Doses" },
          {
            name: "dateOfVaccination",
            label: "Date of Vaccination",
            type: "date",
          },
          { name: "remarks", label: "Remarks" },
        ]}
      /> */}

      {/* {Array.isArray(object?.immunizationHistory) &&
      object?.immunizationHistory.length > 0 ? ( */}
      <ImmunizationHistory
        title="Section III. Immunization History"
        data={object.immunizationHistory}
      />
      {/* ) : null} */}

      {/* 🔥 Conditional Medication Section */}
      {/* {object?.medication || object?.dosage || object?.reason ? (
        <Section
          title="Section IV. Medication"
          fields={[
            { name: "medication", label: "Medication" },
            { name: "dosage", label: "Dosage & Frequency" },
            { name: "reason", label: "Reason for Medication" },
          ]}
        />
      ) : null} */}
      {/* 🔥 Use the new SectionMedication component */}
      {Array.isArray(object?.medication) && object?.medication.length > 0 ? (
        <SectionMedication
          title="Section IV. Medication"
          data={object.medication}
        />
      ) : null}

      <Section
        title="Section V. Addendum"
        fields={[
          // {
          //   name: "medicalCertificate",
          //   label: "Medical Certificate CSC Form 211",
          // },
          // {
          //   name: "sickLeave",
          //   label:
          //     "Sick Leave (Sec, 43, Rule XVI, Omnibus Rules Implementing E.O.No, 292)",
          // },
          { name: "specifyIllness", label: "Specify Illness" },
        ]}
      />
    </div>
  );
}
